var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSolution(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2229",
    xmlSpace: "preserve",
    width: 300,
    height: 300,
    viewBox: "0 0 682.66669 682.66669",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    width: "100%",
    height: "100%",
    transform: "matrix(1,0,0,1,0,0)"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs2233"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath2243"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,512 H 512 V 0 H 0 Z",
    id: "path2241",
    fill: "#0047ba",
    fillOpacity: 1,
    "data-original-color": "#000000ff",
    stroke: "none",
    strokeOpacity: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "g2235",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,682.66667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2237"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2239",
    clipPath: "url(#clipPath2243)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2245",
    transform: "translate(327.2715,270.103)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 0,13.816 2.288,27.537 6.771,40.605 L 12.248,56.57 H -38.746 L -33.27,40.605 C -28.786,27.537 -26.498,13.816 -26.498,0",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    id: "path2247",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2249",
    transform: "translate(448.71,179.3345)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -74.386,-74.386 -194.989,-74.386 -269.375,0 -74.387,74.386 -74.387,194.99 0,269.376 74.386,74.386 194.989,74.386 269.375,0 C 74.387,194.99 74.387,74.386 0,0 Z",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    id: "path2251",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2253",
    transform: "translate(414.6152,205.2729)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -58.104,-53.819 -148.856,-52.485 -205.342,4 -56.368,56.369 -57.813,146.861 -4.336,204.979",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    id: "path2255",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2257",
    transform: "translate(231.6436,437.1768)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 57.58,38.605 136.253,32.47 187.128,-18.405 50.62,-50.62 56.947,-128.76 18.982,-186.26",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    id: "path2259",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2261",
    transform: "translate(32.2354,14.3887)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 -17.847,17.846 c -9.184,9.185 -9.184,24.077 0,33.262 L 82.58,151.535 c 9.185,9.185 24.077,9.185 33.262,0 l 17.846,-17.847 c 9.185,-9.185 9.185,-24.077 0,-33.262 L 33.262,0 C 24.077,-9.185 9.185,-9.185 0,0 Z",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    id: "path2263",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2265",
    transform: "translate(166.4854,193.5308)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 -23.666,-23.666",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    id: "path2267",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2269",
    transform: "translate(169.8643,142.8188)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 23.666,23.667",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    id: "path2271",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2273",
    transform: "translate(99.1943,150.3032)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 51.109,-51.108",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    id: "path2275",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2277",
    transform: "translate(345.459,234.103)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 H -62.873 C -67.416,0 -71.1,3.684 -71.1,8.227 v 19.546 c 0,4.543 3.684,8.227 8.227,8.227 H 0 c 4.543,0 8.227,-3.684 8.227,-8.227 V 8.227 C 8.227,3.684 4.543,0 0,0 Z",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    id: "path2279",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2281",
    transform: "translate(283.8467,234.103)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v -9.948 c 0,-10.191 8.262,-18.453 18.454,-18.453 h 23.443 c 10.193,0 18.455,8.262 18.455,18.453 V 0",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    id: "path2283",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2285",
    transform: "translate(346.6582,270.0059)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 4.094,12.386 10.794,23.88 19.743,33.687 11.497,12.6 18.509,29.362 18.509,47.763 0,39.325 -32.022,71.171 -71.412,70.886 -38.91,-0.282 -70.536,-32.297 -70.362,-71.208 0.081,-18.329 7.119,-35.013 18.609,-47.552 8.938,-9.753 15.6,-21.218 19.667,-33.572",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none"
    },
    id: "path2287",
    fill: "none",
    fillOpacity: 1,
    stroke: "#0047ba",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 15,
    "data-original-stroke-width": 15
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSolution);
export default __webpack_public_path__ + "static/media/icon-solution.c4aa7b772dcdd3391f03b7769f44d65b.svg";
export { ForwardRef as ReactComponent };